import { useCallback } from 'react';
import { Icon } from '@frontend/icons';
import { useNavSize } from '@frontend/responsiveness';
import { useScopedAppFlagStore } from '@frontend/scope';
import { useTaskTrayShallowStore } from '@frontend/task-tray';
import { NakedButton } from '@frontend/design-system';
import { dispatchTopBarModalClose } from '../../events/modal-events';
import { useTopBarShallowStore } from '../../store/use-top-bar-store';
import { iconButtonStyles } from '../../styles/styles';
import { TopBarFocusIds } from '../../utils/focus-registry';

export const TaskTrayButton = () => {
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const hasOnboardingTaskFeatureFlag = getFeatureFlagValue('portal-onboarding-tasks');
  const isTaskTrayIconButtonVisible = false && hasOnboardingTaskFeatureFlag;
  const { selectedIcon, setSelectedIcon } = useTopBarShallowStore('selectedIcon', 'setSelectedIcon');
  const { toggleTaskTrayOpen } = useTaskTrayShallowStore('isTaskTrayOpen', 'toggleTaskTrayOpen');
  const navSize = useNavSize();
  const isMobile = navSize.isLte('mobile');

  const hookTaskTrayClick = useCallback(
    (e?: any) => {
      e?.stopPropagation?.();
      if (selectedIcon === 'taskTray') {
        toggleTaskTrayOpen(false);
        setSelectedIcon('');
      } else {
        if (selectedIcon) dispatchTopBarModalClose();
        toggleTaskTrayOpen(true);
        setSelectedIcon('taskTray');
      }
    },
    [selectedIcon, toggleTaskTrayOpen, setSelectedIcon]
  );

  const handleTaskTrayIconClick = useCallback(
    (e: any) => {
      e?.stopPropagation?.();
      dispatchTopBarModalClose();
      hookTaskTrayClick();
    },
    [hookTaskTrayClick]
  );

  if (!isTaskTrayIconButtonVisible) return null;

  return (
    <li>
      <NakedButton
        id={TopBarFocusIds.taskTray}
        css={iconButtonStyles({ isSelected: selectedIcon === 'taskTray', isMobile })}
        onClick={handleTaskTrayIconClick}
      >
        <Icon name='list' />
      </NakedButton>
    </li>
  );
};
